import type { ComponentType } from 'react';
import {
  CompanyCompanyCollectionReadModelStatus,
  UserWorkspaceUserCollectionReadModelMaxRole,
  GameGameCollectionReadModelStatus
} from '@r/api/generated/client.schemas.ts';

export enum LogicTypeEnum {
  Step = 'STEP',
  Linear = 'LINEAR'
}

export const companyStatuses = Object.values(CompanyCompanyCollectionReadModelStatus);
export const userRoles = Object.values(UserWorkspaceUserCollectionReadModelMaxRole);
export const gameStatuses = Object.values(GameGameCollectionReadModelStatus);

export interface SearchParams {
  [key: string]: string | string[] | undefined;
}

export type Option = {
  label: string;
  value: string;
  icon?: ComponentType<{ className?: string }>;
};

export interface DataTableFilterField<TData> {
  label: string;
  value: keyof TData | string;
  placeholder?: string;
  options?: Option[];
  isDateRange?: boolean;
}

export interface DataTableFilterOption<TData> {
  id: string;
  label: string;
  value: keyof TData | string;
  options: Option[];
  placeholder?: string;
  isDateRange?: boolean;
  filterValues?: string[];
  filterOperator?: string;
  isMulti?: boolean;
}

export interface UploadedFile {
  name: string;
  type: string;
  iri: string;
  pathUri: string;
}
